import { render, staticRenderFns } from "./CartTabs.vue?vue&type=template&id=3403e877&"
import script from "./CartTabs.vue?vue&type=script&lang=js&"
export * from "./CartTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports